import { ComponentType, useCallback, useEffect, useState } from 'react';
import './App.module.css';
import { ExistingUserRow } from './components/ExistingUserRow';
import { Header } from './components/Header';
import { NewUserRow } from './components/NewUserRow';
import { makeRequest } from './service/makeRequest';
import { ExistingUser } from './types/ExistingUser';

export const App: ComponentType = () => {
  const [users, setUsers] = useState<ExistingUser[]>();
  const [draftUser, setDraftUser] = useState<ExistingUser>();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    makeRequest('GET', '/users', undefined, setLoading, setUsers);
  }, []);

  const updateDraftUser: <T extends keyof ExistingUser>(
    property: T,
    value: ExistingUser[T]
  ) => void = useCallback(
    (property, value) =>
      setDraftUser((draftUser) => {
        if (draftUser === undefined) {
          throw new Error('No user is being edited');
        }
        return { ...draftUser, [property]: value };
      }),
    []
  );

  if (isLoading) {
    return <>Loading users...</>;
  }

  if (users === undefined) {
    return <>Users not found</>;
  }

  return (
    <div>
      <Header />
      <main>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>Password</th>
              <th>Super user</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <ExistingUserRow
                draftUser={draftUser}
                onDraftUserUpdated={updateDraftUser}
                onEdit={() => setDraftUser(user)}
                onUserDeleted={() =>
                  setUsers(
                    users.filter(
                      (existingUser) => existingUser.id_user !== user.id_user
                    )
                  )
                }
                onUserSaved={(savedUser) => {
                  setUsers(
                    users.map((existingUser) =>
                      existingUser.id_user === savedUser.id_user
                        ? savedUser
                        : existingUser
                    )
                  );
                  setDraftUser(undefined);
                }}
                onRevert={() => setDraftUser(undefined)}
                user={user}
              />
            ))}
            <NewUserRow
              onUserAdded={(newUser) => setUsers([...users, newUser])}
            />
          </tbody>
        </table>
      </main>
    </div>
  );
};
